import React from 'react';
import {
  Grid,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  makeStyles,
} from '@material-ui/core';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: '16px',
    fontWeight: theme.typography.fontWeightRegular,
  },
  feesName: {
    width: '20%',
    fontSize: '16px',
    fontWeight: '800',
    marginTop: '2%',
    marginBottom: '2%',
  },
  fees: {
    paddingLeft: '8%',
    fontSize: '16px',
    fontWeight: '800',
    marginTop: '2%',
    marginBottom: '2%',
  },
  accordionBox: {
    border: '1px solid #DFDFDF',
    marginTop: '4%',
    marginBottom: '3%',
  },
  classFeesDetails: {
    display: 'flex',
    flexDirection: 'row',
  },
  dashedBorderBottomNoPaddFees: {
    borderBottom: '2px dashed #dfdfdf',
    width: '100%',
  },
  feesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

function FeeStructure({ styles, data }) {
  const classes = useStyles();
  return (
    <div>
      {data.fees ? (
        <Grid item xs={12}>
          <div className={styles.sectionContainer}>
            <div className={styles.section}>
              <div className={styles.subSection}>
                <p className={styles.sectionText}>Fee Structure</p>
                <Grid item xs={12}>
                  {data.fees.map((item, idx) => (
                    <Accordion
                      className={classes.accordionBox}
                      id={idx}
                      key={idx}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header">
                        <Typography className={classes.heading}>
                          {item.forClass} to {item.toClass}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box className={classes.feesContainer}>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Admission Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.admissionFees}/-
                            </Typography>
                          </Box>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Tution Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.tuitionFees}/-
                            </Typography>
                          </Box>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Session Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.sessionFees}/-
                            </Typography>
                          </Box>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Student Kit Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.studentKitFees}/-
                            </Typography>
                          </Box>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Misc. Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.miscFees}/-
                            </Typography>
                          </Box>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Transport Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.transportFees}/-
                            </Typography>
                          </Box>
                          <Box
                            className={
                              classes.dashedBorderBottomNoPaddFees
                            }></Box>

                          {item.customFees
                            ? item.customFees.map((feeType, idx) => (
                                <Box
                                  key={idx}
                                  borderBottom="2px dashed #dfdfdf">
                                  <Box className={classes.classFeesDetails}>
                                    <Typography className={classes.feesName}>
                                      {feeType.feeName}
                                    </Typography>
                                    <Typography className={classes.fees}>
                                      Rs. {feeType.amount}/-
                                    </Typography>
                                  </Box>
                                </Box>
                              ))
                            : null}
                          <Box className={classes.classFeesDetails}>
                            <Typography className={classes.feesName}>
                              Total Annual Fees
                            </Typography>
                            <Typography className={classes.fees}>
                              Rs. {item.totalAnualFees}/-
                            </Typography>
                          </Box>
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Grid>
              </div>
            </div>
          </div>
        </Grid>
      ) : null}
    </div>
  );
}

export default FeeStructure;
